import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskCandidateAvailabilityReminderSent_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskCandidateAvailabilityReminderSent_ActivityLogFragment;
}

const ActivityLogTaskCandidateAvailabilityReminderSent: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.sentAvailabilityReminder"
    />
  );
};

ActivityLogTaskCandidateAvailabilityReminderSent.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskCandidateAvailabilityReminderSent_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskCandidateAvailabilityReminderSent;
